<center-modal [modal]="modal" style="border-radius: 5px; width: 100%;">
  <ion-header>
    <ion-toolbar>
      <ion-title>
        Reconcile
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <div class="content">

      <div class="heading">
        You will be reconciling the below transactions. Please ensure that all selected transactions are of the same type
      </div>
  
      <div class="options">
        <ion-item>
          <ion-label position="stacked">Reconcile as</ion-label>
          <ion-select placeholder="Select type" [(ngModel)]="reconcileType">
            <ion-select-option *ngFor="let option of reconcileOptions">{{option}}</ion-select-option>
          </ion-select>
        </ion-item>
      </div>
  
      <div class="options" *ngIf="reconcileType && reconcileType !== 'Investor'">
        <ion-item>
          <ion-label position="stacked">Reconcile to</ion-label>
          <ion-input [(ngModel)]="reconcileTo" placeholder="e.g. syndicate name"></ion-input> 
        </ion-item>
      </div>
  
      <div class="transactions">
        <table>
          <tr>
            <th></th>
            <th class="text-left">Date</th>
            <th class="text-left">Narration</th>
            <th class="text-right">Transaction</th>
            <th class="text-right">Balance</th>
            <th class="text-center" *ngIf="reconcileType === 'Investor'">Recon</th>
          </tr>
          <ng-container *ngFor="let ind of checked; let i = index">
            <tr *ngIf="firestoreService.paginatedTransactions[ind] as transaction">
              <td class="text-center">
                <ion-button (click)="removeRecon(i)" fill="clear" size="small">
                  <ion-icon name="remove-circle-outline"></ion-icon>
                </ion-button>
              </td>
              <td class="text-left">{{transaction.date | date:'dd/MM/yy'}}</td>
              <td class="text-left">{{transaction.narration}}</td>
              <td class="text-right">{{transaction.transaction | currency}}</td>
              <td class="text-right">{{transaction.bankBalance | currency}}</td>
              <td *ngIf="reconcileType === 'Investor'">
                <div class="center-div" [ngSwitch]="!!investorRecon[i]?.length">
                  <ion-button fill="clear" size="small" class="ion-no-margin" (click)="reconcileTransaction(transaction, i)" *ngSwitchCase="false">
                    <ion-icon name="open-outline"></ion-icon>
                  </ion-button>
                  <ng-container *ngSwitchCase="true">
                    <ion-button fill="clear" size="small" class="ion-no-margin" (click)="expanded[i] = !expanded[i]">
                      <ion-icon class="rotate" name="chevron-down-circle-outline" [class.rotated]="expanded[i]"></ion-icon>
                    </ion-button>
                    <ion-button fill="clear" size="small" class="ion-no-margin" (click)="resetRecon(i)" color="danger">
                      <ion-icon name="close-circle-outline"></ion-icon>
                    </ion-button>
                  </ng-container>
                </div>
              </td>
            </tr>
            <tr *ngIf="expanded[i]">
              <td colspan="5">
                <table>
                  <tr>
                    <th class="text-left">Call Date</th>
                    <th class="text-left">Call Deal</th>
                    <th class="text-right">Transaction Call Amount</th>
                  </tr>
                  <tr *ngFor="let call of investorRecon[i];">
                    <td class="text-left">{{call.date | date:'dd/MM/yy'}}</td>
                    <td class="text-left">{{call.dealName}}</td>
                    <td class="text-right">{{call.amount | currency}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </ng-container>
        </table>
      </div>
  
      <div class="buttons">
        <ion-button color="danger" (click)="dismissModal()">
          Cancel
        </ion-button>
        <ion-button color="success" [disabled]="!reconcileType || (reconcileType && ((reconcileType !== 'Investor' && !reconcileTo) || (reconcileType === 'Investor' && (investorRecon | filterNotEmpty).length !== checked.length)))" (click)="reconcile()">
          Reconcile
        </ion-button>
      </div>

  </div>
</center-modal>